import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetDaypartsByLocationGroup,
  useGetLocationGroup,
  useGetLocationsCountByGroup,
  useGetProjectConfig,
} from 'src/hooks';
import { useDeleteScheduleOrItems } from 'src/hooks/api/schedules/useDeleteScheduleOrItems';
import { useApiErrorNavigator } from 'src/hooks/navigation';

export const useCalendarLocationGroupPage = () => {
  const { locationGroupId = '' } = useParams();
  const [alertVisible, setAlertVisible] = useState(false);

  const {
    data: locationGroup,
    isLoading: isLoadingLocationGroup,
    error,
  } = useGetLocationGroup(locationGroupId.toString(), true);

  const { data: locationsCount = 1, isLoading: isLoadingLocationsCount } =
    useGetLocationsCountByGroup(
      [`locationGroups.id=${locationGroupId}`],
      Boolean(locationGroupId),
    );

  useApiErrorNavigator(error);
  const { data: projectConfig } = useGetProjectConfig();
  const {
    data: activeDaypartOptions = [],
    isLoading: isLoadingActiveDayparts,
  } = useGetDaypartsByLocationGroup(
    [`location_group_id=${locationGroupId}`, 'valid_to.null=true'],
    Boolean(locationGroupId),
  );

  const deleteScheduleComponents = useDeleteScheduleOrItems();

  return {
    locationsCount,
    locationGroup,
    activeDaypartOptions,
    isLoadingActiveDayparts,
    isLoadingLocationGroup,
    isLoadingLocationsCount,
    projectConfig,
    deleteScheduleComponents,
    alertVisible,
    setAlertVisible,
  };
};
